module.exports = __webpack_public_path__ + "img/图片28.813696d5.jpg";